import ExcelJS from "exceljs";
import { PARTNER_COLUMNS } from "./partnerImportModel";

export function buildPartnerImportTemplate(lookups) {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Accountree";
  const sheet = workbook.addWorksheet("Partnerët");
  sheet.columns = PARTNER_COLUMNS;
  sheet.views = [{ state: "frozen", ySplit: 1 }];
  sheet.autoFilter = "A1:K1";
  sheet.getRow(1).height = 32;
  sheet.getRow(1).font = { bold: true };
  sheet.getRow(1).alignment = { wrapText: true, vertical: "middle" };
  ["identification", "vat", "bankAccount", "phone"].forEach(key => { sheet.getColumn(key).numFmt = "@"; });
  sheet.getColumn(14).width = 5;
  const lists = [
    [15, "Shtetet", lookups.states.map(item => item.StateName), "state", "FF2563EB"],
    [16, "Qytetet", lookups.cities.map(item => item.CityName), "city", "FF16803C"],
    [17, "Shteti i qytetit", lookups.cities.map(item => item.StateName || lookups.states.find(state => Number(state.StateID) === Number(item.StateID))?.StateName || ""), null, "FF16803C"],
    [18, "Bankat", lookups.banks.map(item => item.BankName), "bank", "FF8B5CF6"],
  ];
  lists.forEach(([column, header, names, key, color]) => {
    sheet.getColumn(column).width = 30;
    const edge = { style: "thin", color: { argb: color } };
    const border = { top: edge, bottom: edge, left: edge, right: edge };
    sheet.getColumn(column).border = border;
    if (key) sheet.getColumn(key).border = border;
    sheet.getCell(1, column).value = header;
    sheet.getCell(1, column).font = { bold: true };
    names.forEach((name, index) => { sheet.getCell(index + 2, column).value = String(name || ""); });
  });
  sheet.getColumn(20).width = 85;
  sheet.getCell("T1").value = "Udhëzime për klientët dhe furnitorët";
  sheet.getCell("T1").font = { bold: true };
  const notes = [
    "Plotësoni vetëm kolonat A:K nga rreshti 2. Kolonat me * janë të detyrueshme. Listat anash janë referencë, jo partnerë për importim.",
    "Lloji nuk plotësohet në Excel. Pas ngarkimit zgjidhni rreshtat dhe caktoni Klient, Furnitor ose të dyja me checkbox-at. Një partner me të dyja do të ketë dy regjistrime: ledger 105 dhe 302.",
    "Plotësoni emërtimin, numrin identifikues dhe adresën. Numri identifikues lejohet deri në 15 karaktere. Ruajeni si tekst, përfshirë zerot në fillim.",
    "Shteti: kopjoni emrin e saktë nga lista Shtetet (O). Qyteti: kopjoni nga lista Qytetet (P), duke kontrolluar shtetin përkatës në Q. Qyteti duhet t'i takojë shtetit të rreshtit.",
    "Banka është opsionale. Nëse e shënoni, kopjoni emrin nga Bankat (R). Llogaria bankare është opsionale, por kur plotësohet duhet të ketë 16 shifra; mbajeni si tekst.",
    "Numri i TVSH-së është opsional, deri në 15 karaktere. Telefoni, email-i dhe komenti janë opsionalë. Të gjithë partnerët importohen aktivë automatikisht.",
    "Për shumë partnerë, kopjoni emrin nga listat dhe përdorni Fill Down / Ctrl+D në kolonën përkatëse. Ngjyrat e bordurave lidhin kolonat me listat e tyre.",
    "I njëjti numër identifikues mund të figurojë një herë si klient dhe një herë si furnitor. Përsëritja brenda të njëjtit lloj do të shënohet për korrigjim.",
  ];
  notes.forEach((text, index) => {
    const start = index * 4 + 2;
    sheet.mergeCells(start, 20, start + 3, 20);
    sheet.getCell(start, 20).value = text;
    sheet.getCell(start, 20).alignment = { wrapText: true, vertical: "middle" };
  });
  return workbook;
}
